import { NEW_GAME } from './types';

const newGame = () => {
  return {
    type: NEW_GAME
  }
}

export default newGame;
